import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { RoutedModal } from "../../../common";
import { DeleteIntegratedDevice } from "../DeleteIntegratedDevice";
import { IntegratedDeviceForm } from "../IntegratedDeviceForm";
import { useIntegratedDeviceList } from "./useIntegratedDeviceList";

export const IntegratedDeviceTable = ({
  deviceList,
  metaDetails = {},
  gotoPage = () => {},
}) => {
  const {
    instance,
    terminalDetails,
    deleteTerminalDetails,
    setTerminalDetails,
    setDeleteTerminalDetails,
  } = useIntegratedDeviceList({
    deviceList,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center my-5">
          <img
            width="250px"
            height="262px"
            src={Images.tnxEmptyState}
            alt="empty state"
          />
          <h4 className="font-weight-semibold text-center mt-4">
            No terminal found
          </h4>
          <p className="text-center">
            Use the button above to add a terminal. When you do, they would
            appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {deviceList?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <RoutedModal
        isActive={terminalDetails !== null}
        width={600}
        headerTitle="Update Terminal"
        // headerDescription="Select a terminal to receive transfer payment"
        closeModal={() => setTerminalDetails(null)}
        style={{ height: "auto" }}
      >
        <IntegratedDeviceForm
          terminalDetails={terminalDetails}
          isEditMode={true}
          closeModal={() => setTerminalDetails(null)}
        />
      </RoutedModal>

      <secondaryComponents.Modal
        isActive={deleteTerminalDetails !== null}
        width={500}
        closeModal={() => setDeleteTerminalDetails(null)}
      >
        <DeleteIntegratedDevice
          terminalDetails={deleteTerminalDetails}
          closeModal={() => setDeleteTerminalDetails(null)}
        />
      </secondaryComponents.Modal>
    </>
  );
};
